/* eslint-disable */
export default {
  close: '关闭',
} as const;

// @key: @#@"close"@#@ @source: @#@"Close"@#@
